import Loadable from 'react-loadable';

import Loader from '~/components/common/ui/loader/Loader';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const loadable = (loader: () => Promise<any>) => Loadable({ loader, loading: Loader });
